module.exports = __webpack_public_path__ + "static/media/mint-nft-3-steps-vert.a36815e4.png";